import { CountryErrorFragment } from "@saleor/fragments/types/CountryErrorFragment";
import { CountryErrorCode } from "@saleor/types/globalTypes";
import { defineMessages } from "react-intl";
import { IntlShape } from "react-intl";

const messages = defineMessages({
    alreadyExists:{
        defaultMessage:"违反唯一约束，重复值校验失败"
    },
    notFound:{
        defaultMessage:"该字段为必填项"
    },
    unique:{
        defaultMessage:"规则校验失败，请参照ISO标准填写"
    }
})

function getCountryErrorMessage(
    err: Omit<CountryErrorFragment, "__typename"> | undefined,
    intl: IntlShape
):string{
    if(err){
        switch (err.code) {
            case CountryErrorCode.ALREADY_EXISTS:
                return intl.formatMessage(messages.alreadyExists);
            case CountryErrorCode.UNIQUE:
                return intl.formatMessage(messages.unique);
            case CountryErrorCode.NOT_FOUND:
                return intl.formatMessage(messages.notFound);
            case CountryErrorCode.REQUIRED:
                return "";
        }
    }
    return undefined;
}

export default getCountryErrorMessage;
